import axios from "utils/axios";
export const CourseHeaders = {
  "Accept-version": "2.0",
  "Cache-Control": "no-cache, private",
};

class CourseService {
  // Get all courses with pagination
  getAllCourses({page, limit, teamId, order_by, status_id}) {
    let url = `course?page=${page}&limit=${limit}&team_id=${teamId}`;
    
    if (order_by) {
      url += `&order_by=${order_by}`;
    }
    
    if (status_id !== null && status_id !== undefined) {
      url += `&status_id=${status_id}`;
    }
    
    return axios.get(url, {
      headers: CourseHeaders,
    });
  }

  // Get a single course by ID
  getCourse(teamId, courseId, userId = null) {
    let url = `course/${teamId}/${courseId}`;
    if (userId) {
      url += `?user_id=${userId}`;
    }
    return axios.get(url, {
      headers: CourseHeaders,
    });
  }

  // Create a new course
  createCourse(data) {
    if (data instanceof FormData) {
      return axios.post("course", data, {
        headers: {
          ...CourseHeaders,
          "Content-Type": "multipart/form-data"
        },
      });
    }
  }

  // Update an existing course
  updateCourse(courseId, data) {
    if (data instanceof FormData) {
      return axios.put(`course/${courseId}`, data, {
        headers: {
          ...CourseHeaders,
          "Content-Type": "multipart/form-data"
        },
      });
    }
  }

  // Assign course to a team
  assignCourseToTeam(data) {
    return axios.post("course/assign", data, {
      headers: CourseHeaders,
    });
  }

  // Unassign course from a team
  unassignCourseFromTeam(data) {
    return axios.post("course/unassign", data, {
      headers: CourseHeaders,
    });
  }

  // Delete a course
  deleteCourse(teamId, courseId) {
    return axios.delete(`course/${teamId}/${courseId}`, {
      headers: CourseHeaders,
    });
  }

  // Toggle course sharing for a team
  toggleCourseSharing(teamId, enableSharing) {
    return axios.post(`/user/team/toggle-course-sharing`, {
      team_id: teamId,
      enable_sharing: enableSharing
    }, {
      headers: CourseHeaders,
    });
  }

  // Get all teams with course sharing status
  getCourseSharingTeams() {
    return axios.get(`/user/teams/course-sharing`, {
      headers: CourseHeaders,
    });
  }

  // Get all assigned courses for the current user
  getMyCourses(page = 1, limit = 10, teamId = null, order_by = null, status_id = null) {
    let url = `/my-courses?page=${page}&limit=${limit}`;
    
    if (teamId) {
      url += `&team_id=${teamId}`;
    }
    
    if (order_by) {
      url += `&order_by=${order_by}`;
    }
    
    if (status_id !== null && status_id !== undefined) {
      url += `&status_id=${status_id}`;
    }
    
    return axios.get(url, {
      headers: CourseHeaders,
    });
  }

  // Get all courses where the current user is assigned as growth partner
  getGrowthPartnerCourses(page = 1, limit = 10, teamId = null) {
    let url = `/team/${teamId}/growth-partner-courses?page=${page}&limit=${limit}`;
    
    return axios.get(url, {
      headers: CourseHeaders,
    });
  }

  // Submit growth partner feedback for a lesson
  submitGrowthPartnerFeedback(data) {
    return axios.post(`/course/growth-partner/feedback`, data, {
      headers: CourseHeaders,
    });
  }

  // Start a course
  startCourse(courseId, teamId) {
    return axios.post(`/course/start`, {
      course_id: courseId,
      team_id: teamId
    }, {
      headers: CourseHeaders,
    });
  }

  // Assign growth partner for a course
  assignGrowthPartner(courseId, teamId, partnerId, canViewLessonResponses = false) {
    return axios.post(`/course/growth-partner`, {
      course_id: courseId,
      team_id: teamId,
      partner_id: partnerId,
      can_view_lesson_responses: canViewLessonResponses
    }, {
      headers: CourseHeaders,
    });
  }

  // Get growth partner details for a course
  getGrowthPartnerDetails(teamId, courseId) {
    return axios.get(`/course/growth-partner/${teamId}/${courseId}`, {
      headers: CourseHeaders,
    });
  }

  // Submit lesson response
  submitLessonResponse(data) {
    const formData = new FormData();
    
    // Append all fields to form data
    for (const key in data) {
      if (key === 'response_file' && data[key]) {
        formData.append('response_file', data[key]);
      } else {
        formData.append(key, data[key]);
      }
    }
    
    return axios.post(`/course/lesson/response`, formData, {
      headers: {
        ...CourseHeaders,
        "Content-Type": "multipart/form-data"
      },
    });
  }

  // Complete a lesson
  completeLesson(courseId, moduleId, lessonId, teamId) {
    return axios.post(`/course/lesson/complete`, {
      course_id: courseId,
      module_id: moduleId,
      lesson_id: lessonId,
      team_id: teamId
    }, {
      headers: CourseHeaders,
    });
  }

  // Get course progress
  getCourseProgress(teamId, courseId) {
    return axios.get(`/course/progress/${teamId}/${courseId}`, {
      headers: CourseHeaders,
    });
  }
}

export default new CourseService(); 